import React, { useState, useCallback } from "react";
import ReactFlow, {
  Controls,
  Background,
  addEdge,
  applyEdgeChanges,
  applyNodeChanges,
} from "reactflow";
import "reactflow/dist/style.css";
import SearchBar from "../../components/SearchBar";
import Navbar from "../../components/Navbar";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";
import edit_pencil_icon from "../../assets/icons/edit_pencil_icon.png";

import StatusNode from "../../components/StatusNode";

const initialNodes = [
  {
    id: "node-1",
    type: "statusNode",
    position: { x: 0, y: 0 },
    data: { value: 123 },
  },
];

const nodeTypes = { statusNode: StatusNode };

const StatusVertical = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);

  const [nodes, setNodes] = useState(initialNodes);
  const [edges, setEdges] = useState([]);

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };

  const onNodesChange = useCallback(
    (changes) => setNodes((nds) => applyNodeChanges(changes, nds)),
    [setNodes]
  );
  const onEdgesChange = useCallback(
    (changes) => setEdges((eds) => applyEdgeChanges(changes, eds)),
    [setEdges]
  );
  const onConnect = useCallback(
    (connection) => setEdges((eds) => addEdge(connection, eds)),
    [setEdges]
  );

  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Profile" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>

      <div className="ml-4 mt-6">
        <p className="text-[18px]">Status Vertical</p>
      </div>

      <div className="flex justify-between w-[90%] ml-4 mt-4">
        <div className="flex bg-[#F8F8F8] p-3 w-[20%] justify-between rounded-lg cursor-pointer">
          <p className="text-[14px] font-bold">Verification</p>
          <img src={edit_pencil_icon} alt="edit" className="object-contain" />
        </div>
        <div className="flex bg-[#F8F8F8] p-3 w-[20%] justify-between rounded-lg cursor-pointer">
          <p className="text-[14px] font-bold">Discussion</p>
          <img src={edit_pencil_icon} alt="edit" className="object-contain" />
        </div>
        <div className="flex bg-[#F8F8F8] p-3 w-[20%] justify-between rounded-lg cursor-pointer">
          <p className="text-[14px] font-bold">Negotiation</p>
          <img src={edit_pencil_icon} alt="edit" className="object-contain" />
        </div>
        <div className="flex bg-[#F8F8F8] p-3 w-[20%] justify-between rounded-lg cursor-pointer">
          <p className="text-[14px] font-bold">Won/Loss</p>
          <img src={edit_pencil_icon} alt="edit" className="object-contain" />
        </div>
        <div className="bg-[#F8F8F8] flex justify-center w-[2.3rem] items-center ml-2 rounded-md">
          <p className="text-[30px] cursor-pointer">+</p>
        </div>
      </div>

      <div className="h-[70vh] w-[95%] ml-4 mt-4">
        <ReactFlow
          nodes={nodes}
          edges={edges}
          onNodesChange={onNodesChange}
          onEdgesChange={onEdgesChange}
          onConnect={onConnect}
          nodeTypes={nodeTypes}
          fitView
        >
          <Background />
          <Controls />
        </ReactFlow>
      </div>

      <div className="ml-4 flex justify-center mt-2 mb-8">
        <div className="border border-[#2F80ED] text-[#2F80ED] font-bold rounded-lg text-[14px] px-5 py-1 cursor-pointer">
          Add Another Status
        </div>
      </div>
    </div>
  );
};

export default StatusVertical;
